// extracted by mini-css-extract-plugin
export default {"buttonGroup":"InstallButton_buttonGroup__9YAV9","downloadButton":"InstallButton_downloadButton__F5FGV","dropIcon":"InstallButton_dropIcon__1+InH"};